const env=process.env;
const REACT_APP_ENV=env.REACT_APP_ENV;
let baseUrl;
if(REACT_APP_ENV){
  const app_env=REACT_APP_ENV.toUpperCase();
  baseUrl=env[`REACT_APP_${app_env}_BASE_URL`]||env.REACT_APP_DEV_BASE_URL
}else baseUrl= env.REACT_APP_DEV_BASE_URL

console.log("baseURl",baseUrl)
export default baseUrl